import React from 'react';
import propTypes from 'prop-types';
import classNames from 'classnames';

import { rgb } from 'constants/types';

/** A circular bullet with drawn with specified color. */
const ColorBullet = ({
  className,
  color
}) => {
  const classString = classNames({
    'vra-color-bullet': true,
    [`${className}`]: !!className
  });
  const rgb = `rgb(${color.r},${color.g},${color.b})`;
  return (
    <div className={classString}>
      <svg height='100%' width='100%'><circle cx='50%' cy='50%' fill={rgb} r='50%' /></svg>
    </div>);
};

ColorBullet.propTypes = {
  className: propTypes.string,
  color: rgb.isRequired
};

export default ColorBullet;
